
<template>
    <iframe :src="pdfData" width="100%" :height="parentHeight" style="border: none;"></iframe>
</template>

<script>
import settings from "@/backend/LocalSettings"
import BasePage from '@/pages/Admin/BasePage' 
import Constants from '@/backend/Constants'
export default {
    name: "inspectie_finala_pdf",
    extends: BasePage,

    data(){
        return {
            Constants: Constants,
            IdDeviz: this.$route.params.IdDeviz,
            parentHeight: 1000,        
            pdfData:"",
        }
    },
    methods: {
        
    },
    async mounted() {

        var  response = await this.$http.post('login/check_php_login', {token: settings.get_token} );
        if(response) {
            if(response.body.token_activ == 0){
                this.$router.push("/");
            }else{
                this.pdfData = this.Constants.ServerUrl + '/service/devize/inspectie_finala/' + this.IdDeviz
            }
        } else {
            this.$router.push("/");
        }
    }
}
</script>

